import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

export function fmtErr(e) {
  if (e?.message === "Network Error" && !e?.response) {
    return "Cannot reach the server — check your connection, disable ad-blockers/VPN for this site, then hard-refresh (Ctrl+Shift+R).";
  }
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export const money = (v, c = "EUR") => {
  if (v == null) return "—";
  try {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency: String(c || "EUR").toUpperCase() }).format(v);
  } catch {
    return `${Number(v).toFixed(2)} ${String(c || "").toUpperCase()}`;
  }
};

export const fdate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");

export const fdt = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
